import React, { useEffect, useState } from "react";

import Select from "../components/Select";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import SelectCourier from "../components/SelectCourier";
import PaidOrders from "./PaidOrders";
import LinearWithValueLabel from "../components/ProgressLine";
import api from "../hooks/apiClient";
import { CircularProgress } from "@mui/material";
const OrdersPay = () => {
  const [error, setError] = useState(null);
  const [chekDB, setChekDB] = useState(true);
  const [failedOrders, setFailedOrders] = useState(0);
  const [showOrders, setShowOrders] = useState(false);
  const [response, setResponse] = useState("");
  const [orderP, setOrderP] = useState("");
  const [progress, setProgress] = useState();
  const [isProcessing, setIsProcessing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [stores, setStores] = useState([]);
  const [couriers, setCouriers] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileData, setFileData] = useState(null);
  const [selectedStoreId, setSelectedStoreId] = useState("");
  const [selectedCourierId, setselectedCourierId] = useState("");
  const [monthValue, setMonthValue] = useState("");
  const [monthsValue, setMonthsValue] = useState("");
  const [yearValue, setYearValue] = useState("");

  const showToggle = () => {
    setShowOrders(!showOrders);
  };
  const handleSelectChange = (value) => {
    setSelectedStoreId(value);

    if (value) {
      fetchStoresCouriers(value);
    } else {
      setCouriers([]);
    }
  };
  const handleSelectChangeC = (value) => {
    setselectedCourierId(value);
  };
  useEffect(() => {
    const processingJobId = localStorage.getItem("processingJobId");
    if (processingJobId) {
      setIsProcessing(true);
      pollJobStatus(processingJobId);
    }
    api
      .get("stores/all")
      .then((response) => {
        setStores(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);
  const fetchStoresCouriers = async (store_id) => {
    setLoading(true);

    try {
      const couriersResponse = await api.get("couriers/all/bystore", {
        params: {
          store_id: store_id,
        },
      });

      setCouriers(couriersResponse.data);
    } catch (err) {
      console.error("Error fetching stores and couriers:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDivClick = (dataArray, arrayName) => {
    const popupWindow = window.open("", "_blank", "width=600,height=400");

    if (popupWindow) {
      const htmlContent = `
        <div style="font-family: Arial, sans-serif;">
          <h2>${arrayName}</h2>
          <div style="display: flex; flex-wrap: wrap;">
            ${Object.entries(dataArray)
              .map(
                ([key, value]) => `
                <div style="border: 1px solid #ccc; border-radius: 8px; padding: 10px; margin: 10px; width: 230px;  text-align: center;">
                  <h3 style="textalign:center">${key}</h3>
                  ${Object.entries(value)
                    .map(
                      ([subKey, subValue]) =>
                        `<p style="border: 1px solid #ccc; border-radius: 8px; padding: 10px; margin: 10px; width: 200px;"><strong>${subKey}:</strong> ${subValue}</p>`
                    )
                    .join("")}
                </div>
              `
              )
              .join("")}
          </div>
        </div>
      `;
      popupWindow.document.write(htmlContent);
    } else {
      alert(
        "Popup blocked! Please allow popups for this site to see the data."
      );
    }
  };

  const handleFileSelect = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleFileUpload = async () => {
    if (!isProcessing) {
      if (selectedFile && selectedStoreId && selectedCourierId) {
        const formData = new FormData();
        formData.append("excelFile", selectedFile);
        formData.append("storeId", selectedStoreId); // Assuming storeId is a variable containing the store ID
        formData.append("courierId", selectedCourierId);
        formData.append("dbChek", chekDB);

        try {
          setIsProcessing(true);
          const res = await api.post("upload/file", formData);
          setOrderP(res.data.result.orders.length);

          setFileData(res.data.result);
          setResponse("Orders processing initiated. Please wait...");
          pollJobStatus(res.data.jobId); // Start polling for job status
          localStorage.setItem("processingJobId", res.data.jobId);
        } catch (error) {
          console.error("Error processing orders:", error);
          setResponse("Error: " + error.message);
          setIsProcessing(false);
        }
      } else {
        alert("please Select All Fields");
      }
    } else {
      alert("A file upload is already in progress.");
    }
  };
  const handleFileReport = async () => {
    if (monthValue && yearValue && selectedStoreId && selectedCourierId) {
      // const formData = new FormData();
      // formData.append("excelFile", selectedFile);
      // formData.append("storeId", selectedStoreId);
      // formData.append("courierId", selectedCourierId);
      // formData.append("month", monthValue);
      // formData.append("year", yearValue);
      setLoading(true);
      try {
        const res = await api.post("upload/file/report", {
          storeId: selectedStoreId,
          courierId: selectedCourierId,
          month: monthValue,
          months: monthsValue,
          year: yearValue,
        });

        setFileData(res.data);

        setLoading(false);
      } catch (error) {
        console.error("Error processing orders:", error);
        setLoading(false);
      }
    } else {
      alert("please Select All Fields");
    }
  };
  const formatError = (errorResponse) => {
    if (errorResponse && errorResponse.errors) {
      return Object.entries(errorResponse.errors)
        .map(([key, value]) => `${key}: ${value.join(", ")}`)
        .join(", ");
    }
    return "An unexpected error occurred";
  };
  const pollJobStatus = async (jobId) => {
    try {
      const res = await api.get(`upload/file/${jobId}`);

      if (res.data.status === "completed") {
        setResponse("Orders processing completed.");
        setOrderP(res.data.orderPro);
        setFailedOrders(res.data.jobFailed);
        setProgress(100);
        setIsProcessing(false);
        localStorage.removeItem("processingJobId");
      } else if (res.data.status === "processing") {
        setIsProcessing(true);
        setOrderP(res.data.orderPro);
        setProgress(res.data.progress);
        setFailedOrders(res.data.jobFailed);
        setTimeout(() => {
          pollJobStatus(jobId);
        }, 10000);
      } else if (res.data.status === "failed") {
        setResponse("Orders processing ." + res.data.status);
        setError(res.data.failedReason);
        setFailedOrders(res.data.jobFailed);
        setIsProcessing(false);
        localStorage.removeItem("processingJobId");
      } else {
        setResponse("Orders processing ." + res.data.status);
        setFailedOrders(res.data.jobFailed);
        setError(res.data.failedReason);
        setIsProcessing(false);
        localStorage.removeItem("processingJobId");
      }
    } catch (error) {
      console.error("Error polling job status:", error.message);
      setResponse("Error: " + error.message);
      setIsProcessing(false); // Reset processing flag in case of error
      localStorage.removeItem("processingJobId");
    }
  };

  async function stopUpload() {
    api
      .post("upload/stop-loop")
      .then((response) => {
        setResponse("");
        setOrderP("");
        setProgress();
        // setSelectedFile(null);
        // setRealTimeData([]);

        setIsProcessing(false);
        setSelectedStoreId("");
        setselectedCourierId("");
        localStorage.removeItem("processingJobId");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  const handleMonthValue = (event) => {
    setMonthValue(event.target.value);
  };
  const handleYearValue = (event) => {
    setYearValue(event.target.value);
  };
  const handleMonthsValue = (event) => {
    setMonthsValue(event.target.value);
  };
  if (showOrders) {
    return <PaidOrders show={showToggle} />;
  }
  return (
    <div>
      {loading && (
        <div className="loading">
          <CircularProgress /> Loading ...
        </div>
      )}
      <button
        className="btn btn-sm btn-outline-info me-3  float-end"
        onClick={showToggle}
      >
        Show Orders
      </button>
      <div className="container mt-4">
        <p>{error && formatError(error)}</p>
        {(response || progress) && (
          <div className="container ">
            {response && <div>{response}</div>}
            {progress && (
              <div>
                {" "}
                <span className="magic-button magic-button-green mb-1">
                  Orders: {orderP} / Failed {failedOrders}
                </span>
                <div className="">
                  <LinearWithValueLabel progress={progress} />
                </div>
              </div>
            )}
          </div>
        )}
        <div className="shadow p-2 mb-1 bg-body rounded d-flex justify-content-around">
          <div className="">
            <Select
              stores={stores}
              value={selectedStoreId}
              onChange={handleSelectChange}
            />
          </div>
          <div className="">
            <SelectCourier
              couriers={couriers}
              value={selectedCourierId}
              onChange={handleSelectChangeC}
            />
          </div>
          <div className="">
            <input
              className="form-control form-control-sm"
              type="file"
              onChange={handleFileSelect}
            />
          </div>

          <FormControlLabel
            control={
              <Switch
                checked={chekDB}
                onChange={() => setChekDB(!chekDB)}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            label="Sync DB"
          />
          {!isProcessing > 0 && (
            <div className="">
              <div className="">
                <button
                  className="btn btn-info btn-sm"
                  onClick={handleFileUpload}
                >
                  Upload File
                </button>
              </div>
            </div>
          )}
          {isProcessing > 0 && (
            <div className="">
              <button className="btn btn-sm btn-danger" onClick={stopUpload}>
                Stop Upload
              </button>
            </div>
          )}
        </div>
        <div className="shadow p-2 mb-1 bg-body rounded d-flex justify-content-around">
          <div className="">
            <Select
              stores={stores}
              value={selectedStoreId}
              onChange={handleSelectChange}
            />
          </div>
          <div className="">
            <SelectCourier
              couriers={couriers}
              value={selectedCourierId}
              onChange={handleSelectChangeC}
            />
          </div>
          <div className="">
            <select
              className="form-control form-control-sm"
              value={monthValue}
              onChange={handleMonthValue}
            >
              <option value="">Select End Month</option>

              <option value="1">January</option>
              <option value="2">February</option>
              <option value="3">March</option>
              <option value="4">April</option>
              <option value="5">May</option>
              <option value="6">June</option>
              <option value="7">July</option>
              <option value="8">August</option>
              <option value="9">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </select>
          </div>
          <div className="">
            <select
              className="form-control form-control-sm"
              value={yearValue}
              onChange={handleYearValue}
            >
              <option value="">Select a Year</option>
              <option value="2021">2021</option>
              <option value="2022">2022</option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
            </select>
          </div>
          <div className="">
            <select
              className="form-control form-control-sm"
              value={monthsValue}
              onChange={handleMonthsValue}
            >
              <option value="0">Months</option>

              <option value="0">1 Month</option>
              <option value="2">3 Month</option>
              <option value="5">6 Months</option>
              <option value="11">One Year</option>
            </select>
          </div>
          <div className="">
            <button
              className="btn btn-warning btn-sm"
              onClick={handleFileReport}
            >
              Get Report
            </button>
          </div>
        </div>
        {fileData && (
          <div>
            <div className="d-flex flex-wrap justify-content-around">
              {fileData &&
                Object.keys(fileData).map((arrayName, index) => (
                  <div
                    className="shadow p-3 mb-2 bg-body rounded d-flex  flex-column"
                    key={index}
                    onClick={() =>
                      handleDivClick(fileData[arrayName], arrayName)
                    }
                  >
                    <span className="magic-button magic-button-yellow  mb-1">
                      {arrayName.toUpperCase()}
                    </span>
                    <span className="magic-button ">
                      {" "}
                      {fileData[arrayName].length}
                    </span>
                  </div>
                ))}
            </div>
            <div className="d-flex flex-wrap justify-content-around">
              {fileData?.statusArrays &&
                Object.entries(fileData.statusArrays).map(
                  ([status, orders]) => (
                    <div key={status} className="status-section">
                      <div
                        className="shadow p-3 mb-2 bg-body rounded d-flex flex-column"
                        onClick={() => handleDivClick(orders, status)}
                      >
                        <span className="magic-button magic-button-yellow mb-1">
                          {status.toUpperCase()}
                        </span>
                        <span className="magic-button">{orders.length}</span>
                      </div>
                    </div>
                  )
                )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrdersPay;
